module.exports = __webpack_public_path__ + "static/media/SteamshipMutual_V2.fb554168.svg";